import { type ComputedRef, computed } from 'vue'

import TeaserCardItemLarge from '@storefront-satch/components/molecules/teaser-card/TeaserCardItemLarge.vue'
import TeaserCardItemMedium from '@storefront-satch/components/molecules/teaser-card/TeaserCardItemMedium.vue'
import TeaserCardItemMini from '@storefront-satch/components/molecules/teaser-card/TeaserCardItemMini.vue'
import TeaserCardItemSmall from '@storefront-satch/components/molecules/teaser-card/TeaserCardItemSmall.vue'
import type { TeaserCardCarouselOptions } from '@storefront-satch/components/molecules/teaser-card/types'
import type { TeaserCardGroupProps } from '@storefront-satch/components/organisms/teaser-card-group/types'

import tailwindConfig from '@fond-of/satch-tailwind'

const { screens } = tailwindConfig.theme.extend

export const useTeaserCard = (
  size: TeaserCardGroupProps['size'] = 'medium'
) => {
  const carouselOptions: ComputedRef<TeaserCardCarouselOptions> = computed(
    () => ({
      mini: {
        breakpoints: {
          [`(min-width: ${screens.sm})`]: {
            dragFree: false,
            slidesToScroll: 'auto',
            align: 'start',
          },
        },
        dragFree: true,
        slidesToScroll: 'auto',
        containScroll: 'trimSnaps',
        align: 'start',
        pagination: true,
        mobileScrollbar: true,
        prevNextButtons: true,
      },
      small: {
        breakpoints: {
          [`(min-width: ${screens.md})`]: {
            dragFree: false,
            slidesToScroll: 'auto',
            align: 'start',
          },
        },
        dragFree: true,
        slidesToScroll: 'auto',
        containScroll: 'trimSnaps',
        align: 'start',
        pagination: true,
        mobileScrollbar: true,
        prevNextButtons: true,
      },
      medium: {
        breakpoints: {
          [`(min-width: ${screens.sm})`]: {
            dragFree: false,
            slidesToScroll: 'auto',
            align: 'start',
          },
        },
        dragFree: true,
        slidesToScroll: 'auto',
        containScroll: 'trimSnaps',
        align: 'start',
        pagination: true,
        mobileScrollbar: true,
        prevNextButtons: true,
      },
      large: {
        breakpoints: {
          [`(min-width: ${screens.sm})`]: {
            dragFree: false,
            slidesToScroll: 'auto',
            align: 'start',
          },
        },
        dragFree: true,
        slidesToScroll: 'auto',
        containScroll: 'trimSnaps',
        align: 'start',
        pagination: true,
        mobileScrollbar: true,
        prevNextButtons: true,
      },
    })
  )

  const teaserCardItem = computed(() => {
    const mapper = {
      mini: TeaserCardItemMini,
      small: TeaserCardItemSmall,
      medium: TeaserCardItemMedium,
      large: TeaserCardItemLarge,
    }

    return mapper[size as keyof typeof mapper]
  })

  return {
    carouselOptions:
      carouselOptions.value[size as keyof typeof carouselOptions.value] ||
      carouselOptions.value.medium,
    teaserCardItem,
  }
}
